import { useMemo } from 'react';
import { useCookieCutter } from '@unisporkal/react-cookie-cutter';
import {
  SearchPreferencesFactory,
  type SearchPreferences,
  type SearchProfile,
} from 'app/domain';
import { SearchPreferenceCookie } from './searchPreferenceCookie';

const factory = new SearchPreferencesFactory();

const useSearchPreferences = (
  searchProfile: SearchProfile
): SearchPreferences => {
  const cookie = useCookieCutter(SearchPreferenceCookie);

  return useMemo(
    () =>
      factory.fromDTO(cookie, {
        excludeNudity: searchProfile.excludeNudity,
      }),
    [searchProfile, cookie]
  );
};

export default useSearchPreferences;
